import React, { useState, useEffect } from 'react';
import api from "../../api";
import CustomerUserTable from '../../components/UserTable/CustomerUserTable';
import StatCard from '../../components/Profile/StatCard ';
import { toPersianNumbers } from "../../utils/toPersianNumbers";
import { exportToExcel } from "../../utils/exportToExcel"; // import تابع جدید
import Button from "../../components/Button";

export default function CustomerUserManagement() {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [totalUsers, setTotalUsers] = useState(0);
  const [activeUsers, setActiveUsers] = useState(0);
  const [newUsersLast7Days, setNewUsersLast7Days] = useState(0);
  const [exportLoading, setExportLoading] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await api.get("accounts/admin/users/customers/");
      const data = Array.isArray(response.data) ? response.data : [];
      setProfiles(data);

      // محاسبات آماری
      setTotalUsers(data.length);
      const activeCount = data.filter((p) => p.is_active).length;
      setActiveUsers(activeCount);

      const oneWeekAgo = new Date();
      oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
      const newCount = data.filter((p) => {
        if (!p.date_joined) return false;
        const joinedDate = new Date(p.date_joined);
        return joinedDate >= oneWeekAgo;
      }).length;
      setNewUsersLast7Days(newCount);

    } catch (err) {
      setError('خطا در بارگذاری لیست کاربران');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };



  // تابع مدیریت خروجی اکسل
  const handleExportExcel = () => {
    if (!profiles.length) {
      alert("داده‌ای برای خروجی وجود ندارد");
      return;
    }
    exportToExcel(profiles, "لیست_مشتریان", {
      headers: {
        full_name: "نام و نام خانوادگی",
        customer_code: "کد مشتری",
        phone_number: "موبایل",
        province: "استان",
        city: "شهر",
        is_active: "وضعیت",
        date_joined: "تاریخ ثبت‌نام",
      },
    });
  };


  return (
      <div className="p-6">
        {/* خطا */}
        {error && (
            <div className="mb-4 text-red-600">
              {error}
            </div>
        )}

        {/* هدر با دکمه خروجی */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">مدیریت مشتریان</h1>
        </div>

        {/* کارت‌های آمار */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
          <StatCard title={'تعداد کل کاربران'} value={toPersianNumbers(totalUsers)}/>
          <StatCard title={'کاربران فعال'} value={toPersianNumbers(activeUsers)}/>
          <StatCard title={'کاربران جدید (۷ روز گذشته)'} value={toPersianNumbers(newUsersLast7Days)}/>
        </div>

        <div>
          <Button
            onClick={handleExportExcel}
            children = {'خروجی اکسل'}
            className={'mb-[16px]'}/>
        </div>

  <div>
    <CustomerUserTable profiles={profiles} loading={loading}/>
  </div>
</div>
)
  ;
};